// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"80d18bfc","670":"da630bfd"}[chunkId] + ".chunk.js";
};